/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {CommandMap, CommandsDescriptor} from '@app/models/commands/commands-descriptor';
import {MessageRecord} from '@app/services/data.service';
import {ChatService} from '@app/modules/chat/services/chat.service';
import {Store} from '@ngxs/store';
import {ExecBuffer} from '@app/models/exec-buffer';

export enum ChatEvents {
  MESSAGE = 'MESSAGE',
  CLEAR_MESSAGES = 'CLEAR_MESSAGES',
  CLEAR_USER_MESSAGES = 'CLEAR_USER_MESSAGES',
  RESET_SCORE = 'RESET_SCORE',
  CLASS_WIDE_MESSAGE='CLASS_WIDE_MESSAGE'
}

export enum ChatStates {
  SCORE = 'SCORE'
}


@Injectable({
  providedIn: 'root'
})
export class ChatCommands extends CommandsDescriptor<ChatEvents, ChatStates> {

  static category = 'CHAT';

  constructor(private chatService: ChatService, store: Store) {

    const MAP: CommandMap<ChatEvents, ChatStates> = {

      EVENT: {
        MESSAGE: (record: MessageRecord) => this.chatService.onMessage(record),
        CLEAR_MESSAGES: () => this.chatService.onClearMessages(),
        CLEAR_USER_MESSAGES: (record: MessageRecord) => this.chatService.onClearUserMessages(record),
        RESET_SCORE: (record: MessageRecord) => this.chatService.onResetScore(record),
        CLASS_WIDE_MESSAGE:(record: MessageRecord)=>this.chatService.onClassWideMessage(record)
      },
      STATE: {
        SCORE: (record: MessageRecord) => this.chatService.onScore(record)
      }
    };
    super(MAP, new ExecBuffer(true), store);
    this.chatService.handleRecordStack = this.handleRecordStack.bind(this);
  }
}
